import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';
import styled from 'styled-components';
import { IntercomAPI } from 'react-intercom';
import { isMobile } from 'react-device-detect';

import Icon from '../Icon/';
import NavbarItem from '../NavbarItem';
import Intercom from '../Intercom';
import history from '../../history';
import { useUserMe } from 'apiTyped/hooks/users.query';

const NavbarContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  width: 90px;
  margin: 0;
  background-color: white;
  -webkit-transition: all 200ms cubic-bezier(0.47, 0, 0.745, 0.715);
  transition: all 200ms cubic-bezier(0.47, 0, 0.745, 0.715);
  position: fixed;
  z-index: 100;
  height: 100%;

  @media (max-width: ${(props) =>
    props.theme.devices.isTablet ? '0px' : '845px'}) {
    left: ${(props) => (props.$expanded ? '0' : '-100%')};
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 100% !important;
    margin: 0;
    z-index: 100;
    position: fixed;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .container-logo {
      width: 184px;
      margin: 15px auto !important;
    }

    .visible {
      opacity: ${(props) => (props.$expanded ? '0' : '1')};
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 3px;
      color: white;
      display: flex;
      justify-content: center;
    }

    .linkAccount {
      text-decoration: none;
    }

    .triangle {
      margin: auto;
    }
    ::-webkit-scrollbar {
      display: none;
    }
    .filter {
      display: none !important;
    }
  }

  .mobileMenu {
    display: none;
    @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
      display: flex;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 70px;
      justify-content: center;
      align-items: center;
      z-index: 9999;
      background-color: #e25c34;
      transition: 0.5s;

      .menu-button {
        width: 20px;
        height: 20px;
        padding: 10px;
        margin: 15px auto auto 25px;
        border-radius: 50%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        position: relative;
        background: #eee;
        border: solid 1px #eee;
        cursor: pointer;
        transform: scale(1);
      }

      .menu-circle {
        position: absolute;
        top: -1px;
        left: -1px;
        width: 100%;
        height: 100%;
        border-radius: 50%;
        border: solid 1px #fff;
      }

      .menu-line {
        width: 22px;
        height: 3px;
        transition: transform 0.3s ease;
        background-color: rgb(226, 93, 52);
        border-radius: 10px;
      }

      .initials {
        background-color: white;
        width: 45px;
        height: 45px;
        border-radius: 50%;
        display: ${(props) => (props.$expanded ? 'none' : 'flex')};
        font-size: 1em;
        justify-content: center;
        align-items: center;
        margin-right: 25px;
        margin-top: 3px;
        font-family: ${(props) => props.theme.fonts.oswald_light};
        color: ${(props) => props.theme.colors['terra-cotta']};
      }

      ${(props) =>
        props.$expanded
          ? `
      pointer-events: all;
      background-color: #e25c3400;
        .menu-button {
          .menu-line:nth-of-type(1) {
            transform: translateY(6px) rotate(45deg);
          }
          .menu-line:nth-of-type(2) {
            transform: translateX(0px);
            opacity: 0;
            transition: all 0.5s ease;
          }
          .menu-line:nth-of-type(3) {
            transform: translateY(-7px) rotate(-45deg);
          }

          .menu-circle:nth-of-type(1) {
            transform: scale(2.5);
            opacity: 0;
            transition: all 0.3s linear;
          }
          .menu-circle:nth-of-type(2) {
            transform: scale(1.8);
            background-color: rgb(226, 93, 52);
            opacity: 0;
            transition: all 0.3s linear;
          }
        }
      `
          : null}
    }
  }

  ${(props) =>
    props.$expanded
      ? `
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    width: 288px;
    margin: 0;
    z-index: 100;
    position: fixed;
    -ms-overflow-style: none;
    scrollbar-width: none;
    .container-logo {
      width: 184px;
      margin-left: 37px;
      margin-top: 29px;
    }
    ::-webkit-scrollbar {
      display: none;
    }`
      : ``}

  ${(props) =>
    props.$expanded
      ? `
      .filter {
        display: block;
        position: fixed;
        width: 200vw;
        height: 200vh;
        background-color: #00000070;
        z-index: 999;
        animation: opacity 0.5s;
        top: 0;
        left: 288px;
      }`
      : `
      filter {
        display: none;
      }
    `}

  @keyframes appear; {
    from {
      opacity: 0;
    }

    to {
      opacity: 100;
    }
  }

  @keyframes opacity {
    from {
      opacity: 0;
    }

    to {
      opacity: 100;
    }
  }

  .left-sidebar-expanded {
    display: inline-flex;
    flex-wrap: wrap;
    width: 200px;
    margin: 0;
    overflow: hidden;
  }

  .container-logo {
    width: ${(props) => (props.$expanded ? '184px' : '50px')};
    height: 40px;
    margin-bottom: 30px;
    margin-left: 20px;
    overflow: hidden;
    margin-top: 30px;
    @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: 184px;
    }

    ${(props) => (props.isTablet ? 'margin-bottom:15px;' : '')}
  }

  .container-logo:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .header-sidebar-wrapper {
    position: relative;
    flex: 1;
    min-height: 0;
    width: inherit;
  }

  .header-sidebar-wrapper::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(to bottom, transparent, white);
    pointer-events: none;
    transition: opacity 0.3s ease;
    opacity: 1;
  }

  .header-sidebar-wrapper.scrolled-to-bottom::after {
    opacity: 0;
  }

  .header-sidebar {
    width: inherit;
    height: 100%;
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .tabletButton {
    width: 20px;
    height: 20px;
    padding: 10px;
    margin: 15px auto auto 25px;
    border-radius: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    position: relative;
    background: #eee;
    border: solid 1px #eee;
    cursor: pointer;
    transform: scale(1);
  }

  .tabletButtonLine {
    width: 22px;
    height: 3px;
    background: #222;
    transition: transform 0.3s ease;
    background-color: rgb(226, 93, 52);
    border-radius: 10px;
  }

  ${(props) =>
    props.$expanded &&
    `
        .tabletButton {
          .tabletButtonLine:nth-of-type(1) {
            transform: translateY(6px) rotate(45deg);
          }
          .tabletButtonLine:nth-of-type(2) {
            transform: translateX(0px);
            opacity: 0;
            transition: all 0.5s ease;
          }
          .tabletButtonLine:nth-of-type(3) {
            transform: translateY(-7px) rotate(-45deg);
          }

          .tabletButtonCircle:nth-of-type(1) {
            transform: scale(2.5);
            opacity: 0;
            transition: all 0.3s linear;
          }
          .tabletButtonCircle:nth-of-type(2) {
            transform: scale(1.8);
            background-color: rgb(226, 93, 52);
            opacity: 0;
            transition: all 0.3s linear;
          }
        }
      `}
`;

const BottomSideBarContainer = styled.div`
  margin-top: auto;
  width: 100%;
  background-color: #2b3d54;

  .helpContainer {
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    height: 75px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    cursor: pointer;

    ${(props) => props.isTablet && 'height:55px;'}
  }

  .helpContainer a {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    text-decoration: none;
  }

  .helpIcon {
    color: white;
  }

  .helpText {
    margin-left: 10px;
    color: white;
    font-family: ${(props) => props.theme.fonts.oswald_light};
    font-size: 14px;
    text-transform: uppercase;
    text-decoration: none;
  }

  .triangle {
    width: 0;
    height: 0;
    transition: border-width 0.3s;
    border-style: solid;
    border-width: ${(props) =>
      props.$expanded ? '8px 144px 0 144px' : '8px 45px 0 45px'};
    border-color: ${(props) => props.theme.colors['terra-cotta']} transparent
      transparent transparent;
  }

  .navbarProfilContainer {
    background-color: #2b3d54;
    height: 204px;
    width: 100%;
    transition: all 10s ease-in-out;
    display: flex;
    flex-direction: column;
  }

  .navbarProfil {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 30px;
  }

  .navbarProfilImage {
    width: 40px;
    height: 40px;
    border-radius: 100%;
  }
  .navbarProfilName {
    color: white;
    margin-top: ${(props) => (props.$expanded ? '0px' : '10px')};
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 14px;
  }

  .navbarProfilExpanded {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 30px;
    margin-left: 20px;
  }

  .settingsLink {
    color: white;
    text-decoration: underline white;
    font-family: ${(props) => props.theme.fonts.oswald};
    margin-top: 4px;
    opacity: 0.5;
    font-size: 12px;
  }

  .navbarProfilNameContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 15px;

    animation-duration: 1s;
    animation-name: appear;
  }

  .navbarProfilExit {
    margin-left: ${(props) => (props.$expanded ? 'auto' : 0)};
    margin-right: ${(props) => (props.$expanded ? '20px' : 0)};
    margin-top: ${(props) => (props.$expanded ? '0px' : '30px')};
  }

  .navbarProfilExit:hover {
    cursor: pointer;
  }

  .initials {
    height: 40px;
    width: 40px;
    border-radius: 50%;
    overflow: hidden;
    background-color: ${(props) => props.theme.colors['terra-cotta']};
    color: white;
    text-transform: uppercase;
    font-size: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.oswald};
  }

  .legalsContainer {
    margin-top: auto;
    margin-bottom: 30px;
    margin-left: 20px;

    ${(props) => props.isTablet && 'margin-top:20px;'}
  }
`;

const IntercomContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  .intercomClose {
    animation: opacity 1000ms ease-in;
    position: fixed;
    font-size: 12px;
    bottom: 70px;
    right: 15px;
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #e25d34;
    color: white;
    border-radius: 50%;
    z-index: 9;
  }

  .intercomClose:hover {
    opacity: 0.8;
    cursor: pointer;
  }

  .intercomClose > * {
    color: white;
    width: 16px;
    height: 16px;
  }
`;

class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      expanded: false,
      intercomOpen: null,
      deployedItem: '',
      initialRoute: '',
      scrolledToBottom: false
    };
  }

  componentDidMount() {
    this.setState({
      initialRoute: window.location.pathname,
      intercomOpen: true
    });
  }

  componentDidUpdate(prevProps) {
    const { intercomOpen, initialRoute } = this.state;
    if (!intercomOpen && prevProps != this.props) {
      this.setState({ intercomOpen: true });
    }

    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent
      );

    if (window.innerWidth < 851 && !isTablet) {
      if (initialRoute != window.location.pathname) {
        this.setState({
          initialRoute: window.location.pathname,
          expanded: false
        });
      }
    }
  }

  renderBottomSidebar(user, isTablet) {
    const { expanded } = this.state;
    let { firstname, lastname } = user;
    return (
      <BottomSideBarContainer isTablet={isTablet} $expanded={expanded}>
        <a className="helpContainer" href="https://intercom.help/wineservices">
          {' '}
          <div className="helpIcon">
            <Icon icon="helper" />
          </div>
          {expanded && (
            <p
              className="helpText"
              onClick={() => {
                this.setState({ intercomOpen: true });
                IntercomAPI('show');
              }}
            >
              {I18n.t('navBar.help')}
            </p>
          )}
        </a>
        <div className="triangle" />
        <div className="navbarProfilContainer">
          {expanded ? (
            <React.Fragment>
              <div className="navbarProfilExpanded">
                <div className="initials">
                  {firstname && lastname && `${firstname[0]}.${lastname[0]}`}
                </div>
                <div className="navbarProfilNameContainer">
                  <p className="navbarProfilName">
                    {firstname && lastname && `${firstname} ${lastname}`}
                  </p>
                  <Link to="/admin" className="settingsLink">
                    <p>{I18n.t('navBar.profile')}</p>
                  </Link>
                </div>
                <div
                  className="navbarProfilExit"
                  onClick={() => this.props.logout()}
                >
                  <Icon icon="exit" />
                </div>
              </div>
              <div className="legalsContainer">
                <a
                  href="/mentions-legales"
                  target="_blank"
                  className="settingsLink"
                >
                  <p>{I18n.t('navBar.legalNotice')}</p>
                </a>
              </div>
            </React.Fragment>
          ) : (
            <div className="navbarProfil">
              <div className="initials">
                <p>
                  {firstname && lastname && `${firstname[0]}.${lastname[0]}`}
                </p>
              </div>
              <p className="navbarProfilName">
                {firstname && lastname && `${firstname} ${lastname[0]}.`}
              </p>
              <Link to="/admin" className="settingsLink">
                <p>{I18n.t('navBar.profileShort')}</p>
              </Link>
              <div
                className="navbarProfilExit"
                onClick={() => this.props.logout()}
              >
                <Icon icon="exit" />
              </div>
            </div>
          )}
        </div>
      </BottomSideBarContainer>
    );
  }

  render() {
    const { data, user } = this.props;
    const { expanded, deployedItem, intercomOpen } = this.state;

    let { firstname, lastname } = user;
    const userAgent = navigator.userAgent.toLowerCase();
    const isTablet =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
        userAgent
      );

    return (
      <React.Fragment>
        <NavbarContainer
          $expanded={expanded}
          isTablet={isTablet}
          className="left-sidebar"
          onMouseEnter={
            !isMobile && !isTablet
              ? () => this.setState({ expanded: true })
              : undefined
          }
          onMouseLeave={
            !isMobile && !isTablet
              ? () => this.setState({ expanded: false })
              : undefined
          }
        >
          <div className="mobileMenu">
            <div
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.setState({ expanded: !expanded });
              }}
              className="menu-button"
            >
              <span className="menu-line" />
              <span className="menu-line" />
              <span className="menu-line" />
            </div>
            {!expanded && (
              <div
                className="container-logo visible"
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  history.push('/dashboard');
                }}
              >
                <Icon icon="logoCustom" className="icon-logo-small" />
              </div>
            )}
            <Link to="/admin" className="linkAccount">
              <div className="initials">
                {firstname && lastname && `${firstname[0]}.${lastname[0]}`}
              </div>
            </Link>
          </div>
          {isTablet && (
            <div
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                this.setState({ expanded: !expanded });
              }}
              className="tabletButton"
            >
              <span className="tabletButtonLine" />
              <span className="tabletButtonLine" />
              <span className="tabletButtonLine" />
            </div>
          )}
          <Link to="/dashboard">
            <div className="container-logo">
              <Icon icon="logo" className="icon-logo-small" />
            </div>
          </Link>
          <div
            className={`header-sidebar-wrapper${
              this.state.scrolledToBottom ? ' scrolled-to-bottom' : ''
            }`}
          >
            <div
              className="header-sidebar"
              onScroll={(e) => {
                const { scrollTop, scrollHeight, clientHeight } = e.target;
                const isAtBottom = scrollHeight - scrollTop - clientHeight < 10;
                if (isAtBottom !== this.state.scrolledToBottom) {
                  this.setState({ scrolledToBottom: isAtBottom });
                }
              }}
            >
              {data.map((item) => (
                <NavbarItem
                  {...item}
                  isTablet={isTablet}
                  retractMenu={() => this.setState({ expanded: false })}
                  key={item.title}
                  onMouseEnter={() =>
                    deployedItem != item.title && !isTablet
                      ? this.setState({ deployedItem: '' })
                      : undefined
                  }
                  expanded={expanded}
                  deployed={deployedItem === item.title}
                  onDeploy={(titleItem) =>
                    this.setState({
                      deployedItem:
                        this.state.deployedItem === titleItem ? '' : titleItem
                    })
                  }
                />
              ))}
            </div>
          </div>
          {this.renderBottomSidebar(user, isTablet)}
          <div
            className="filter"
            onMouseEnter={
              !isTablet ? () => this.setState({ expanded: false }) : undefined
            }
            onClick={() => this.setState({ expanded: false })}
          />
        </NavbarContainer>

        {intercomOpen && (
          <IntercomContainer className="intercomContainer">
            <Intercom user={user} />
            <div
              className="intercomClose"
              onClick={() => this.setState({ intercomOpen: false })}
            >
              <Icon icon="close" />
            </div>
          </IntercomContainer>
        )}
      </React.Fragment>
    );
  }
}

const Index = (props) => {
  const { user } = useUserMe();
  return <Navbar {...props} user={user} />;
};

export default Index;
